import { createApiClient } from './base-api';

export const twig = createApiClient();

export default twig;
